<template>
  <div>
    <template v-if="!loading">
      <v-main-header />
      <router-view />
      <v-cookies-banner v-if="!cookiesAccepted" @accepted="cookiesAccepted = true" />
    </template>
    <v-loader v-else />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { VLoader } from "shared";
import VMainHeader from "@/components/v-main-header";
import VCookiesBanner from "@/components/v-cookies-banner";

export default {
  name: "app",
  components: {
    VLoader,
    VMainHeader,
    VCookiesBanner,
  },
  data() {
    return {
      loading: true,
      cookiesAccepted: false,
    };
  },
  methods: {
    ...mapActions({
      setLanguage: "translations/setLanguage",
      getUserDetails: "user/getUserDetails",
    }),
  },
  async created() {
    this.loading = true;
    const user = await this.getUserDetails();
    await this.setLanguage(user && user.locale);
    this.cookiesAccepted = this.$cookies.get("cookiesAccepted");
    this.loading = false;
    sessionStorage.removeItem("hidePillTooltip");
    sessionStorage.removeItem("hideSearchTooltip");
  },
};
</script>

<style lang="scss">
@import "styles/styles.scss";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0;
  padding: 0;
}
</style>
